// extracted by mini-css-extract-plugin
module.exports = {"collections":"styles_collections__qQZrY","collectionsSnapScroller":"styles_collectionsSnapScroller__WtZCU","collectionsGrid":"styles_collectionsGrid__TMowM"};